var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "SalesDashboardCard",
    {
      attrs: {
        title: "Top 5 companies",
        "class-card": "col-md-4",
        "selected-filter": _vm.selectedFilter,
        filters: _vm.filters
      },
      on: { "set-filter": _vm.setFilter }
    },
    [
      _c(
        "div",
        { attrs: { slot: "body" }, slot: "body" },
        [
          _vm.loading
            ? _c("Loader")
            : _c("div", [
                _c("div", { staticClass: "d-flex align-items-center" }, [
                  _c("span", { staticClass: "legend mr-3" }, [
                    _c("span", { staticClass: "legend-claim" }),
                    _vm._v("\n          Claims\n        ")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "legend" }, [
                    _c("span", { staticClass: "legend-job" }),
                    _vm._v("\n          Jobs\n        ")
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "mt-3 d-flex flex-column" },
                  _vm._l(_vm.companies, function(company) {
                    return _c(
                      "div",
                      {
                        key: company.company_id,
                        staticClass: "top-company-wrap row"
                      },
                      [
                        _c("div", { staticClass: "col-5" }, [
                          _c("span", { staticClass: "company-name" }, [
                            _vm._v(_vm._s(company.company_name))
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-2 d-flex align-items-center" },
                          [
                            _c(
                              "svg",
                              {
                                staticClass: "vue-star-rating-star",
                                attrs: {
                                  "data-v-21f5376e": "",
                                  "data-v-34cbeed1": "",
                                  height: "14",
                                  width: "14",
                                  viewBox: "0 0 14 14",
                                  step: "10"
                                }
                              },
                              [
                                _c(
                                  "linearGradient",
                                  {
                                    attrs: {
                                      "data-v-21f5376e": "",
                                      id: "o8z3ss",
                                      x1: "0",
                                      x2: "100%",
                                      y1: "0",
                                      y2: "0"
                                    }
                                  },
                                  [
                                    _c("stop", {
                                      attrs: {
                                        "data-v-21f5376e": "",
                                        offset: "100%",
                                        "stop-color": "#ffd055"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("stop", {
                                      attrs: {
                                        "data-v-21f5376e": "",
                                        offset: "100%",
                                        "stop-color": "#d8d8d8"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "filter",
                                  {
                                    attrs: {
                                      "data-v-21f5376e": "",
                                      id: "y3cylm",
                                      height: "130%",
                                      width: "130%",
                                      filterUnits: "userSpaceOnUse"
                                    }
                                  },
                                  [
                                    _c("feGaussianBlur", {
                                      attrs: {
                                        "data-v-21f5376e": "",
                                        stdDeviation: "0",
                                        result: "coloredBlur"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "feMerge",
                                      { attrs: { "data-v-21f5376e": "" } },
                                      [
                                        _c("feMergeNode", {
                                          attrs: {
                                            "data-v-21f5376e": "",
                                            in: "coloredBlur"
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("feMergeNode", {
                                          attrs: {
                                            "data-v-21f5376e": "",
                                            in: "SourceGraphic"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("polygon", {
                                  attrs: {
                                    "data-v-21f5376e": "",
                                    points:
                                      "6.363636363636363,0.7070707070707071,2.121212121212121,14,12.727272727272727,5.515151515151515,0,5.515151515151515,10.606060606060606,14",
                                    fill: "url(#o8z3ss)",
                                    stroke: "#fff",
                                    filter: "url(#y3cylm)"
                                  }
                                }),
                                _vm._v(" "),
                                _c("polygon", {
                                  attrs: {
                                    "data-v-21f5376e": "",
                                    points:
                                      "6.363636363636363,0.7070707070707071,2.121212121212121,14,12.727272727272727,5.515151515151515,0,5.515151515151515,10.606060606060606,14",
                                    fill: "url(#o8z3ss)",
                                    stroke: "#999",
                                    "stroke-width": "0",
                                    "stroke-linejoin": "miter"
                                  }
                                }),
                                _vm._v(" "),
                                _c("polygon", {
                                  attrs: {
                                    "data-v-21f5376e": "",
                                    points:
                                      "6.363636363636363,0.7070707070707071,2.121212121212121,14,12.727272727272727,5.515151515151515,0,5.515151515151515,10.606060606060606,14",
                                    fill: "url(#o8z3ss)"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("span", { staticClass: "company-rating" }, [
                              _vm._v(_vm._s(company.rating))
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-5 d-flex align-items-center" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "w-50 d-flex align-items-center mr-1"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "w-100 d-flex align-items-center justify-content-end mr-2"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "claim-progress position-relative",
                                        style: {
                                          width:
                                            _vm.calculateClaimPercentForProgress(
                                              company.count_claims
                                            ) + "%"
                                        }
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "counter-claims" },
                                          [_vm._v(_vm._s(company.count_claims))]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "w-50 d-flex align-items-center" },
                              [
                                _c("div", { staticClass: "w-100" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "job-progress position-relative",
                                      style: {
                                        width:
                                          _vm.calculateJobPercentForProgress(
                                            company.count_jobs
                                          ) + "%"
                                      }
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "counter-jobs" },
                                        [_vm._v(_vm._s(company.count_jobs))]
                                      )
                                    ]
                                  )
                                ])
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  })
                )
              ])
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a01f63d2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a01f63d2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/salesDashboard/subcomponents/cards/TopCompanies.vue
// module id = null
// module chunks = 